import { render, staticRenderFns } from "./SignatureSelector.vue?vue&type=template&id=6c74974e&scoped=true&"
import script from "./SignatureSelector.vue?vue&type=script&lang=ts&"
export * from "./SignatureSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SignatureSelector.vue?vue&type=style&index=0&id=6c74974e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c74974e",
  null
  
)

export default component.exports